import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";
import shopOfferService from "../services/singleShopOffers";

const initialState: any = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  couponCode: null,
  offerType: null,
  isActive: null,
  isFilterApplied: false,
  created_at: null,
  updated_at: null,
  isApplyAll: false,
  isSelectProduct: false,
  leftSide: false,
  products: [],
  offerData: {},
  prefilledForm: false,
  currentPage: 1,
};

const Slice: sagaSlice = createSlice({
  ...persist("allShopOfferManagement", initialState),
  reducers: {
    ...createSagaReducer("fetchShopOffers", "list"),
    updateCouponCode: (state, action) => {
      state.couponCode = action.payload;
    },
    updateOfferType: (state, action) => {
      state.offerType = action.payload;
    },
    updateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    updateIsFilterApplied: (state, action) => {
      state.isFilterApplied = action.payload;
    },
    updateCreatedAt: (state, action) => {
      state.created_at = action.payload;
    },
    updateUpdatedAt: (state, action) => {
      state.updated_at = action.payload;
    },
    updateProducts: (state, action) => {
      state.products = action.payload;
    },
    setLeftSide: (state, action) => {
      state.leftSide = action.payload;
    },
    setIsApplyAll: (state, action) => {
      state.isApplyAll = action.payload;
    },
    setIsSelectProduct: (state, action) => {
      state.isSelectProduct = action.payload;
    },
    updateOfferData: (state, action) => {
      state.offerData = action.payload;
    },
    updatePrefilledForm: (state, action) => {
      state.prefilledForm = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
  },
});

const fetchAllShopOffers = createAsyncSaga(
  "fetchShopOffers",
  Slice,
  shopOfferService.fetchShopOffers,
  [
    "shopId",
    "currentPage",
    "itemsPerPage",
    "couponCode",
    "offerType",
    "isActive",
    "created_at",
    "updated_at",
  ]
);

addSaga(Slice.actions.fetchShopOffers.type, fetchAllShopOffers);

export const {
  fetchShopOffers,
  updateCouponCode,
  updateOfferType,
  updateIsActive,
  updateIsFilterApplied,
  updateCreatedAt,
  updateUpdatedAt,
  updateProducts,
  setIsSelectProduct,
  setIsApplyAll,
  setLeftSide,
  updateOfferData,
  updatePrefilledForm,
  setCurrentPage,
} = Slice.actions;

export default Slice.reducer;
